/* tslint:disable */
/* eslint-disable */
/**
 * Optimizely Private Flags API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * A list of urls.
 * @export
 * @interface UrlList
 */
export interface UrlList extends Array<string> {
}

export function UrlListFromJSON(json: any): UrlList {
    return UrlListFromJSONTyped(json, false);
}

export function UrlListFromJSONTyped(json: any, ignoreDiscriminator: boolean): UrlList {
    return json;
}

export function UrlListToJSON(value?: UrlList | null): any {
    return value;
}


